import { createContext } from 'react';
import type { IMcToast } from '@maersk-global/mds-components-core-toast';

export type ToastContextState = {
  showToast: (message: string, type: IMcToast['appearance']) => void;
};

const ToastContext = createContext<ToastContextState | undefined>(undefined);

export default ToastContext;
